import { Box } from "@mui/material";
import Chart from "react-apexcharts";
import CustomToolTip from "../../../../../components/CustomTooltip";
import gauge_colors from "./gauge_colors.png";
import gauge_colors_rotated from "./gauge_colors_rotated.png";

// Please don't round, floor, or ceil the value before passing it. Let the gauge handle it.
export default function EntityTypeGauge({
  settings,
  value,
  tooltipText = "",
  invertColorScale = false,
}) {
  if (value < 0) value = 0;
  if (value > 100) value = 100;

  if (value > 0 && value < 1) value = 1;
  else if (value > 99 && value < 100) value = 99;
  else value = Math.round(value);

  const r = settings.r;
  const x0 = settings.x0;
  const y0 = settings.y0;
  const angleInDegrees = (value / 100) * 180 - 90;
  const angleInRadians = (angleInDegrees * Math.PI) / 180;
  const dial_bottom_position = y0 + r * Math.cos(angleInRadians) * 1.05;
  const dial_left_position = x0 + r * Math.sin(angleInRadians);
  const gauge_colors_img = invertColorScale
    ? gauge_colors_rotated
    : gauge_colors;
  return (
    <CustomToolTip title={tooltipText} placement="bottom">
      <Box>
        <Box
          width={settings.boxWidth}
          height={settings.boxHeight}
          position="relative"
          sx={{ pointerEvents: "none" }}
        >
          <Box position="relative" top="-10%" right="50%">
            <Chart
              key={value}
              width={settings.width}
              height={settings.height}
              options={{
                stroke: {
                  lineCap: "round",
                },
                fill: {
                  type: "image",
                  image: {
                    src: [gauge_colors_img],
                    width: settings.imgDimension,
                    height: settings.imgDimension,
                  },
                },
                plotOptions: {
                  radialBar: {
                    hollow: {
                      size: "43%",
                    },
                    startAngle: -90,
                    endAngle: 90,
                    dataLabels: {
                      name: {
                        show: false,
                      },
                      value: {
                        show: true,
                        fontSize: "13px",
                        fontFamily: "Poppins",
                        offsetY: 2,
                        formatter: function () {
                          return value + "%";
                        },
                      },
                    },
                  },
                },
                chart: {
                  animations: { enabled: false, speed: 0, easing: "linear" },
                },
              }}
              series={[100]}
              type="radialBar"
            />
            {/* Dial */}
            <Box
              sx={{
                width: 0,
                height: 0,
                borderLeft: "3px solid transparent",
                borderRight: "2px solid transparent",
                borderTop: "11px solid gray",
                position: "absolute",
                bottom: `${dial_bottom_position}px`,
                left: `${dial_left_position}px`,
                transform: `rotate(${angleInDegrees}deg)`,
                transformOrigin: "center",
                "::after": {
                  content: '""',
                  position: "absolute",
                  top: "-16px",
                  left: "-3px",
                  width: "5px",
                  height: "6px",
                  backgroundColor: "gray",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                  borderBottom: "none",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </CustomToolTip>
  );
}
